import { Stack, Switch, Typography } from "@mui/material";
import HorizontalFill from "@entrilia/shared/components/HorizontalFill.tsx";
import { isLineBasedSerie } from "../../../../viewer/chart/helper.ts";
import { getShowPoints } from "../../../../viewer/chart/style/serie/getShowPoints.ts";
import { useAppDispatch } from "../../../../../store/hooks/useAppDispatch.ts";
import { fieldsStateActions } from "../../../../../store/thunks/fieldStatesThunks.ts";
import type { ChartStyleSettings, SeriesSettings } from "../../../../../../../../../api/types/svTypes.ts";

interface Props {
  settings: ChartStyleSettings;
  serie: SeriesSettings;
  readonlyMode: boolean;
}

export default function ShowPointsItem({ settings, serie, readonlyMode }: Props) {
  const supported = isLineBasedSerie(settings, serie);
  const showPoints = getShowPoints(serie);
  const dispatch = useAppDispatch();

  if (!supported) {
    return <></>;
  }

  return (
    <Stack direction="row" sx={{ alignItems: "center" }}>
      <Typography sx={{ color: "text.secondary" }}>Show Points</Typography>
      <HorizontalFill />
      <Switch
        checked={showPoints}
        disabled={readonlyMode}
        onChange={(_, value) =>
          dispatch(fieldsStateActions.updateSeriesSettings({ name: serie.name, changes: { showPoints: value } }))
        }
      />
    </Stack>
  );
}
